const shareCapitalOptions = [
  { id: "AllotmentOfShares", title: "Allotment of Shares", disabled: false },
  { id: "SharesTransfer", title: "Shares Transfer", disabled: true },
  {
    id: "TransmissionOfShares",
    title: "Transmission of Shares",
    disabled: true,
  },
  { id: "ForefeitureOfShares", title: "Forfeiture of Shares", disabled: true },
  { id: "SurrenderOfShares", title: "Surrender of Shares", disabled: true },
  { id: "SharesConsolidation", title: "Shares Consolidation", disabled: true },
  { id: "ShareSubDivision", title: "Shares Sub-division", disabled: true },
  { id: "SharesBuyBack", title: "Shares Buy-back", disabled: true },
  { id: "SharesRedemption", title: "Shares Redemption", disabled: true },
  {
    id: "NoticeOfChangeOfName",
    title: "Notice of Change of Name/Designation of a Class of Shares",
    disabled: true,
  },
  {
    id: "NoticeOfParticularsOfVariation",
    title: "Notice of Particulars of Variation of Class Rights of Shares",
    disabled: true,
  },
  {
    id: "ReductionOfShareCapital",
    title: "Reduction of Share Capital",
    disabled: true,
  },
  { id: "TakeoverOffer", title: "Takeover Offer", disabled: true },
];

export default shareCapitalOptions;
